import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import './assets/css/custom.css';
import '@fontsource/raleway';
import '@fontsource/raleway/400.css';
import '@fontsource/raleway/400-italic.css';
import { CssBaseline, ThemeProvider } from '@mui/material';
import App from './App';
import theme from './Theme/theme';
import './i18n';

const root = ReactDOM.createRoot( document.getElementById( 'root' ) );
root.render(
    <>
        <CssBaseline/>
        <ThemeProvider theme={theme}>
            <App/>
        </ThemeProvider>
    </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
